export default __webpack_public_path__ + "static/media/laptop_coin_left.4717da22.png";